interface TranscriptionViewModelInput {
  isOpen: boolean;
  isMinimized: boolean;
  hasSession: boolean;
  recordingPhase: "idle" | "recording" | "paused";
  /** true durante finalizing/analyzing/analysis_failed — mantem a barra visivel mesmo com recordingPhase idle. */
  isBusy?: boolean;
}

export function buildTranscriptionViewModel({
  isOpen,
  isMinimized,
  hasSession,
  recordingPhase,
  isBusy = false,
}: TranscriptionViewModelInput) {
  const activeRecording = recordingPhase === "recording" || recordingPhase === "paused" || isBusy;
  return {
    showSheet: isOpen && !isMinimized && hasSession,
    showMiniBar: isOpen && isMinimized && hasSession && activeRecording,
    primaryControl:
      recordingPhase === "paused"
        ? ("resume" as const)
        : recordingPhase === "recording"
          ? ("pause" as const)
          : ("start" as const),
  };
}
